import { actionTypes } from "../actions/feedbackActions";
import { SET_OPTION_FEEDBACK } from "../actions/experienceAction";
import { UPDATE_COMMON_COMPONENT_RESPONSE } from "../actions/commonComponentAction";
import { SET_SUBMIT_SELECTED_OPTION } from "../actions/submitPageComponentAction";
import { SET_SELECTED_LANGUAGE } from "../actions/selectedLanguageAction";

export const initialState = {
  options: [],
  currentStep: 0,
  currentSubStep: 0,
  feedbackData: {
    Selected_Language: 'English',
  },
  completedOptions: [],
  showThanks: false,
  currentOptionSelected: null,
  experienceSelected: {},
};

export function feedbackReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_STEP:
      return {
        ...state,
        currentStep: action.payload.step,
        currentSubStep: action.payload.subStep,
      };

    case SET_OPTION_FEEDBACK: {
      const { option, experience, comment} = action.payload;
      return {
        ...state,
        feedbackData: {
          ...state.feedbackData,
          [option]: {
            ...state.feedbackData[option],
            experience,
            comment,
          },
        },
      };
    }

    case UPDATE_COMMON_COMPONENT_RESPONSE: {
      const { option, questionKey, questionText, response } = action.payload;
      return {
        ...state,
        feedbackData: {
          ...state.feedbackData,
          [option]: {
            ...state.feedbackData[option],
            responses: {
              ...state.feedbackData[option]?.responses,
              [questionKey]: {
                questionText,
                response,
              },
            },
          },
        },
      };
    }

    case SET_SUBMIT_SELECTED_OPTION:{
      const { option } = action.payload;
      return {
        ...state,
        feedbackData: {
          ...state.feedbackData,
          Contact_Back: 
            option,          
        }
      };
    }

    case SET_SELECTED_LANGUAGE:{
      const { selectedLanguage} = action.payload;
      return {
        ...state,
        feedbackData: {
          ...state.feedbackData,
          Selected_Language: 
            selectedLanguage,          
        }
      };
    }

    case actionTypes.REMOVE_OPTION:
      const updatedOptions = state.options.filter((opt) => opt !== action.payload.option);
      const adjustedStep = Math.min(state.currentStep, updatedOptions.length - 1);
      const updatedFeedbackData = Object.keys(state.feedbackData)
        .filter((key) => key !== action.payload.option)
        .reduce((obj, key) => {
          obj[key] = state.feedbackData[key];
          return obj;
        }, {});
      return {
        ...state,
        options: updatedOptions,
        feedbackData: updatedFeedbackData,
        currentStep: adjustedStep,
      };

    case actionTypes.COMPLETE_OPTION:
      return {
        ...state,
        completedOptions: [...state.completedOptions, action.payload.option],
      };

    case actionTypes.SUBMIT_FEEDBACK:
      return {
        ...state,
        showThanks: true,
        completedOptions: [],
        feedbackData: {},
      };

    case actionTypes.SET_CURRENT_OPTION_SELECTED:
      return {
        ...state,
        currentOptionSelected: action.payload,
      };
    case actionTypes.SET_EXPERIENCE_SELECTED:
      return {
        ...state,
        experienceSelected: {
          ...state.experienceSelected,
          [action.payload.option]: action.payload.isSelected,
        },
      };
      case actionTypes.SET_TEAMS_VIDEO_ROOM_FEEDBACK: {
        const { option, question, response } = action.payload;
        return {
          ...state,
          feedbackData: {
            ...state.feedbackData,
            [option]: {
              ...state.feedbackData[option],
              responses: {
                ...state.feedbackData[option]?.responses,
                "question": { 
                  questionText: question,
                  response: response,
                },
              },
            },
          },
        };
      }
      case actionTypes.SET_DIGITAL_SERVICE_FEEDBACK: {
        const { option, questionKey, question, response } = action.payload;
        return {
          ...state,
          feedbackData: {
            ...state.feedbackData,
            [option]: {
              ...state.feedbackData[option],
              responses: {
                ...state.feedbackData[option]?.responses,
                [questionKey]: {
                  questionText: question,
                  response: response,
                },
              },
            },
          },
        };
      }
      case actionTypes.SET_IT_SERVICE_DESK_FEEDBACK: {
        const { option, questionKey, question, response, comment } = action.payload;
        return {
          ...state,
          feedbackData: {
            ...state.feedbackData,
            [option]: {
              ...state.feedbackData[option],
              responses: {
                ...state.feedbackData[option]?.responses,
                [questionKey]: {
                  questionText: question,
                  response: response,
                  comment: comment, 
                },
              },
            },
          },
        };
      }

      case actionTypes.SET_MOBILE_TELEPHONY_FEEDBACK: {
        const { option, mainCategory, subCategory, comments } = action.payload;
        return {
          ...state,
          feedbackData: {
            ...state.feedbackData,
            [option]: {
              ...state.feedbackData[option],
              responses: {
                mainCategory: {
                  questionText: "Select category for which you would like to provide feedback on?",
                  response: mainCategory, 
                },
                subCategory: {
                  questionText: "Select a sub-category for feedback:",
                  response: subCategory, 
                },
                comments: {
                  questionText: "Please tell us more about your experience:",
                  response: comments, 
                },
              },
            },
          },
        };
      }
      case actionTypes.SET_OFFICE_NETWORK_FEEDBACK: {
        const { option, question, selectedOptions, feedbackPrompt, comments } = action.payload;
        return {
          ...state,
          feedbackData: {
            ...state.feedbackData,
            [option]: {
              ...state.feedbackData[option],
              responses: {
                question1: {
                  questionText: question,
                  response: selectedOptions, 
                },          
                question2: {
                  questionText: feedbackPrompt,
                  response: comments, 
                },
              },
            },
          },
        };
      }  
      case actionTypes.SET_PHILIPS_IT_FEEDBACK: {
        const { option, question } = action.payload;
        return {
          ...state,
          feedbackData: {
            ...state.feedbackData,
            "Philips IT cloud orchestration": {
              ...state.feedbackData["Philips IT cloud orchestration"],
              responses: {
                questionText: question,
                response: option, 
              },
            },
          },
        };
      }

      case actionTypes.SET_IT_EXPERIENCE_FEEDBACK: {
        const { option, question, comments, itExperienceLocation } = action.payload;
        return {
          ...state,
          feedbackData: {
            ...state.feedbackData,
            "IT Experience Center": {
              ...state.feedbackData["IT Experience Center"],
              responses: {
                questionText: question, 
                selectedOption: option, 
                comments: comments, 
                itExperienceLocation: itExperienceLocation,
              },
            },
          },
        };
      }      
      
                   
    default:
      return state;
  }
}
